<template>
  <div :class="[`group-248 fontawesome5free-solid-normal-white-24px`, className || ``]">
    <img
      class="rectangle-86-6"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/rectangle-86.svg"
      alt="Rectangle 86"
    />
    <img
      class="rectangle-87-5"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/rectangle-87.svg"
      alt="Rectangle 87"
    />
    <div class="text-273"></div>
    <div class="text-274"></div>
  </div>
</template>

<script>
export default {
  name: "Group248",
  props: ["className"],
};
</script>

<style>
.group-248 {
  height: 50px;
  left: 1576px;
  position: absolute;
  top: 831px;
  width: 124px;
}

.rectangle-86-6 {
  height: 50px;
  left: 70px;
  position: absolute;
  top: 0;
  width: 50px;
}

.rectangle-87-5 {
  height: 50px;
  left: 0;
  position: absolute;
  top: 0;
  width: 50px;
}

.text-273 {
  left: 89px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 11px;
  width: 12px;
}

.text-274 {
  left: 19px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 11px;
  width: 12px;
}

.group-248.view-219,
.group-248.view-220 {
  left: unset;
  margin-left: 1534px;
  margin-top: 39px;
  position: relative;
  top: unset;
  width: 124.21px;
}

.group-248.view-221,
.group-248.view-223,
.group-248.view-224,
.group-248.view-225 {
  left: 1586px;
  top: 2px;
}

.group-248.group-248-2,
.group-248.group-248-4,
.group-248.group-248-5,
.group-248.group-248-6 {
  left: unset;
  margin-left: 1632px;
  margin-top: 35px;
  position: relative;
  top: unset;
  width: 124.21px;
}

.group-248.view-222 {
  left: unset;
  margin-left: 1566.8px;
  margin-top: 60px;
  position: relative;
  top: unset;
  width: 124.3px;
}
</style>
